import React, { Component } from "react";
import reward from "./assets/images/reward.gif";
import Header from "./Common/Header/Header";
import "./Rewards.css";
import { Button } from "reactstrap";
class Rewards extends Component {
  constructor(props) {
    super(props);
    if (
      this.props.location == undefined ||
      this.props.location.state == undefined
    ) {
      this.props.history.goBack();
    }
  }

  handler = (view) => {
    this.props.history.push(view);
  };

  render() {
    return (
      <>
        <Header isBackBtnShow={true} />
        {this.props.location.state && (
          <>
            <Button className="backButt" onClick={() => this.handler("/home")}>
              Back to Menu
            </Button>
            <div style={{ overflowX: "hidden", textAlign: "center" }}>
              <div>
                <div
                  style={{
                    padding: "10px",
                    fontSize: "30px",
                    color: "#dc977c",
                  }}
                >
                  Congratulations!
                </div>

                <h2 style={{ color: "#3E2723" }}>
                  You have earned {this.props.location.state.points} points
                </h2>
                <br></br>
                <div className="img_div">
                  <img className="img" src={reward} />
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default Rewards;
